<template>
  <m-demo-box demo-option="search">
    <div slot="top">
      <m-demo-all-check />
    </div>
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="search-box">
            <b-input v-model.lazy="searchKey"
                     class="search-input"
                     placeholder="Enter Your Keywords"
                     data-test="demo-search-searchInput"
                     :disabled="isAllHoseholds" />
            <m-error-text :val="searchKey"
                          :immediate="searchKey.length > 0"
                          class="error-notice"
                          :rules="[{
                            type: 'minLength',
                            payload: 3,
                            desc: 'At least 3 words'
                          }]"/>
          </div>

        </b-col>
      </b-row>
      <b-row>
        <b-col md="5">
          <m-loader size="before" :show="!hasLoad"/>
          <b-select v-model = "selectedAttributes"
                    :select-size="7"
                    class="demo-select"
                    multiple
                    data-test="demo-search-select"
                    :disabled="isAllHoseholds">
            <option v-for="item in demos"
                    :value="item"
                    :class="{'demos-column':item.IsGroup === 1 }"
                    class="demos-value">
              {{item.desc}}
            </option>
            <option v-show ="demos.length === 0 && hasLoad" disabled>No Record</option>
          </b-select>
        </b-col>
        <b-col md="2" class="m-select-btn-box">
          <b-btn class="m-select-btn"
                 size="sm"
                 @click="addDemos()"
                 data-test="demo-search-add"
                 :disabled="isAllHoseholds">
            Add</b-btn>
          <b-btn class="m-select-btn"
                 size="sm"
                 @click="deleteDemos()"
                 data-test="demo-search-remove"
                 :disabled="isAllHoseholds">
            Remove</b-btn>
          <b-btn class="m-select-btn"
                 @click="cleanDemos()"
                 size="sm"
                 data-test="demo-search-clean"
                 :disabled="isAllHoseholds">
            Remove All</b-btn>
        </b-col>
        <b-col md="5">
          <b-select v-model = "unSelectedDemos"
                    :select-size="7"
                    class="demo-select"
                    multiple
                    data-test="demo-search-selected"
                    :disabled="isAllHoseholds">
            <option v-for="item in selectedDemos"
                    :value="item" :class="{'demos-column':item.type === 'column' }" class="demos-value">
              {{item.name}}
            </option>
          </b-select>
        </b-col>
      </b-row>
    </b-container>
  </m-demo-box>
</template>

<script>
  import MDemoAllCheck from '@/components/demo/MDemoAllCheck'
  import MDemoBox from '@/components/demo/MDemoBox'
  import MErrorText from '@/components/common/MerrorText'

  export default {
    components: {
      MDemoAllCheck,
      MDemoBox,
      MErrorText
    },
    data () {
      return {
        searchKey: '',
        selectedAttributes: [],
        unSelectedDemos: [],
        demos: [],
        hasLoad: true
      }
    },
    watch: {
      '$route.params.listType' () {
        this.demos = []
        this.searchKey = ''
      },
      searchKey (val) {
        if (val.length < 3) {
          return false
        }
        this.hasLoad = false
        this.$http.get('BA/DemoAutoSuggestion.ashx', {
          params: {
            Keyword: val,
            ListType: this.$store.state.order.ListType
          }
        }).then(resp => {
          this.demos = resp.body
          this.hasLoad = true
          for (let i = 0; i < this.demos.length; i++) {
            let demo = this.demos[i]
            if (demo.IsGroup === 1) {
              this.demos[i].desc = demo.AttributeDesc
              this.demos[i].name = demo.AttributeName
              this.demos[i].type = 'column'
            } else {
              this.demos[i].desc = demo.AttributeValueName
              this.demos[i].name = demo.AttributeValue
              this.demos[i].type = 'value'
            }
          }
        }, resp => {
          this.hasLoad = true
        })
      }
    },
    computed: {
      listType () {
        return this.$store.state.order.ListType
      },
      selectedDemos () {
        let demos = this.$store.getters['order/demoItems']
        let result = []
        for (let column of demos) {
          result.push({
            type: 'column',
            columnName: column.ColumnName,
            name: column.AttributeName,
            demoCategoryType: column.DemoCategoryType
          })
          for (let value of column.Values) {
            result.push({
              type: 'value',
              attributeValue: value.AttributeValue,
              columnName: value.ColumnName,
              name: value.AttributeValueName,
              demoCategoryType: column.DemoCategoryType
            })
          }
        }
        return result
      },
      isAllHoseholds () {
        return this.$store.getters['order/isAllHoseholds']
      }
    },
    created () {
    },
    methods: {
      addDemos () {
        for (let item of this.selectedAttributes) {
//          item.AttributeName = this.columns[this.selectedColumn].AttributeName
//          item.AttributeDesc = this.columns[this.selectedColumn].AttributeDesc
          if (item.IsGroup === 0) {
            item.DemoCategoryType = 3
            this.$store.dispatch('order/addDemoByItem', item)
          }
        }
      },
      cleanDemos () {
        this.$store.commit('order/clearDemos')
      },
      deleteDemos () {
        for (let item of this.unSelectedDemos) {
          this.$store.dispatch('order/deleteDemo', item)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .box {
    padding-left: 8px;
    padding-right: 8px;
    display: block;
  }

  .demos-column.demos-value {
    color: $color-black;
    font-weight: bold;
    margin-left: 0;
  }
  .demos-value {
    margin-left: 16px;
  }
  .search-input {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .error-notice {
    position: absolute;
    top: 8px;
    right: 16px;
  }
  .search-box {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/DemoSearch.vue